<template>
  <div class="cancel-reason app-region blank-t-v blank-l-h blank-r-h">
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newCancelReason()">新增取消原因</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="repair_cancel_order_reason_id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.is_show === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editCancelReason(data)">编辑</a-button>
          <a-button type="link" @click="delCancelReason(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="取消原因" prop="content">
          <a-textarea v-model="form.content" placeholder="请输入取消原因"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CancelReasonService from '@/io/cancel_reason.js';

  export default {
    name: 'RepairItems',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {},
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '取消原因',
              dataIndex: 'cancel_order_reason'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        form: {
          content: null,
        },
        rules: {
          content: [
            {
              required: true,
              message: '请填写取消原因'
            }
          ]
        },
        modal: {
          id: null,
          title: null,
          show: false,
          loading: false
        },
      }
    },
    mounted () {
      this.initData();
    },
    methods: {
      stateChange(data) {
        let checked = data.is_show === 1;
        data.stateLoading = true;
        CancelReasonService[checked ? 'offline' : 'online'](data.repair_cancel_order_reason_id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.is_show = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      newCancelReason() {
        this.modal.id = null;
        this.form.content = null;
        this.modal.title = '新增取消原因';
        this.modal.show = true;
      },
      delCancelReason(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此取消原因？',
          onOk() {
            CancelReasonService.del(data.repair_cancel_order_reason_id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      editCancelReason(data) {
        this.modal.id = data.repair_cancel_order_reason_id;
        this.form.content = data.cancel_order_reason;
        this.modal.title = '编辑取消原因';
        this.modal.show = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.modal.loading = true;
          if (this.modal.id) {
            CancelReasonService.edit(this.modal.id, this.form.content).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.initData();
              });
            }).catch(err => {}).finally(() => {
              this.modal.loading = false;
              this.modal.show = false;
            });
          } else {
            CancelReasonService.add(this.form.content).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.initData();
              });
            }).catch(err => {}).finally(() => {
              this.modal.loading = false;
              this.modal.show = false;
            });
          }
        });
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        CancelReasonService.listPage(
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>